import { Injectable, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from 'gung-common';
import { LanguageConfigService } from 'gung-standard';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TyloLanguageConfigService extends LanguageConfigService {
  public getLanguages(): Language[] {
    return [
      {
        language: 'finland',
        short: 'fi',
        image: 'finland-flag-round-icon-256.png',
        enabled: environment.projectName === 'helo' && environment.mainCountry === 'fi'
      },
      {
        language: 'france',
        short: 'fr',
        image: 'france-flag-round-icon-256.png',
        enabled: false
      },
      {
        language: 'germany',
        short: 'de',
        image: 'germany-flag-round-icon-256.png',
        enabled: false
      },
      {
        language: 'norway',
        short: 'no',
        image: 'norway-flag-round-icon-256.png',
        enabled: false
      },
      {
        language: 'portugal',
        short: 'pt',
        image: 'portugal-flag-round-icon-256.png',
        enabled: false
      },
      {
        language: 'sweden',
        short: 'se',
        image: 'sweden-flag-round-icon-256.png',
        enabled: environment.projectName === 'tylo' && environment.mainCountry === 'se'
      },
      {
        language: 'united-kingdom',
        short: 'en',
        image: 'united-kingdom-flag-round-icon-256.png',
        enabled: true
      }
    ];
  }
}
